import { Inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { NXDataSourcePrime } from '../../services/dataSource/NXDataSourcePrime';
import * as fromGraphQl from './graphql';
import { ConnectedDevice } from '../../entities/connected-device/connected-device';

export class MobileDeviceDataSource extends NXDataSourcePrime<ConnectedDevice> {
  constructor(
    apollo: Apollo,
    @Inject('env') environment : any
    ) {
    super(apollo, fromGraphQl.MOBILE_DEVICES_QUERY, environment);
  }
  handleSubscriptionResult(data: fromGraphQl.MobileDevicesQueryResponse): void {
    super.setSubject(
      data.mobileDevices?.content ? data.mobileDevices?.content : [],
      data.mobileDevices?.totalElements ? data.mobileDevices.totalElements : 0
    );
  }

  loadDevices(variables: any): void {
    this.querySubscription?.unsubscribe();
    this.subscribeToQuery(variables);
  }
}
